export default __webpack_public_path__ + "static/media/professional_person.c7c32ad5.png";